/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Fade from 'react-reveal/Fade';

import Button from 'elements/Button';

import BuildWebsite from 'assets/images/Startup.png';

export default function Hero() {
  return (
    <section className="hero">
      <Fade bottom>
        <div className="w-full lg:w-1/2 xl:pl-12 sm:pr-2 mt-8">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl text-theme-blue font-bold leading-tight mb-6 tracking-tight">
            Innovation
            {' '}
            <span className="bg-gradient-to-r from-theme-purple to-dark-theme-purple bg-clip-text text-transparent">
              Automation
            </span>
            {' '}
            <br />
            Acceleration
          </h1>

          <p className="font-light text-xl lg:text-2xl text-gray-600 leading-relaxed mb-8 max-w-3xl">
            Modern, Usable, ROI-Driven, AI-based Business Digitization & Optimization
            {' '}
            <br className="hidden sm:block" />
            With Human-Like AI Assistants
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12 max-w-4xl">
            <div className="text-center bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-gray-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <svg className="w-6 h-6 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4a2 2 0 012-2h2" />
                </svg>
              </div>
              <div className="text-lg font-bold text-theme-purple mb-1">UI/UX &</div>
              <div className="text-xs text-gray-600">Product Design</div>
            </div>
            <div className="text-center bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-gray-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <svg className="w-6 h-6 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <div className="text-lg font-bold text-theme-purple mb-1">AI Process</div>
              <div className="text-xs text-gray-600">Digitization</div>
            </div>
            <div className="text-center bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-gray-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <svg className="w-6 h-6 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <div className="text-lg font-bold text-theme-purple mb-1">AI/ML</div>
              <div className="text-xs text-gray-600">Solutions</div>
            </div>
            <div className="text-center bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-gray-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <svg className="w-6 h-6 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="text-lg font-bold text-theme-purple mb-1">Web & Mobile</div>
              <div className="text-xs text-gray-600">Application</div>
            </div>
            <div className="text-center bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-gray-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <svg className="w-6 h-6 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
                </svg>
              </div>
              <div className="text-lg font-bold text-theme-purple mb-1">AI DevOps</div>
              <div className="text-xs text-gray-600">Services</div>
            </div>
            <div className="text-center bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-gray-100 hover:shadow-lg transition-all duration-300 hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                <svg className="w-6 h-6 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div className="text-lg font-bold text-theme-purple mb-1">Scaling</div>
              <div className="text-xs text-gray-600">Applications</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button href="/case-studies" type="link" className="group flex w-auto items-center px-8 py-4 text-white text-lg bg-gradient-to-r from-theme-purple to-dark-theme-purple rounded-xl shadow-lg hover:shadow-2xl transform transition-all duration-300 hover:scale-105 hover:-translate-y-1">
              Explore Our Work
              <svg className="ml-2 w-6 h-6 text-white transform group-hover:translate-x-1 transition-transform duration-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Button>
            <Button href="/discuss-project" type="link" className="group flex w-auto items-center px-8 py-4 text-theme-purple text-lg bg-white border-2 border-theme-purple rounded-xl shadow-md hover:shadow-lg transform transition-all duration-300 hover:scale-105 hover:-translate-y-1">
              Contact Us
              <svg className="ml-2 w-6 h-6 text-theme-purple transform group-hover:translate-x-1 transition-transform duration-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </Button>
          </div>
        </div>
      </Fade>

      <Fade bottom>
        <div className="flex pt-5 w-full justify-center items-center order-first md:w-full lg:order-last lg:w-1/2">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-theme-purple/20 to-dark-theme-purple/20 rounded-3xl blur-3xl transform -rotate-6" />
            <img className="relative transform hover:scale-105 transition-transform duration-500" src={BuildWebsite} alt="Build Website" />
          </div>
        </div>
      </Fade>
    </section>
  );
}
